<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="toggleForm">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <div class="flex-grow-1"></div>
        <v-toolbar-items>
          <v-btn dark text @click="dialog = false">Save</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-stepper>
        <v-stepper-header>
          <v-stepper-step
            editable
            step="1"
          >
            Upload the photo
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            step="2"
          >Create an ad group</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            step="3"
            editable
          >
            Create an ad
          </v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card
              class="mb-12"
              color="grey lighten-1"
            >
              <v-card-text>
                <v-form>
                  <v-container
                    class="fill-height"
                    style="min-height: 434px"
                    fluid
                  >
                    <v-row
                      justify="center"
                    >
                      <input type="file" id="file-upload" style="display:none" @change="onFileChange">
                      <v-btn
                        color="primary"
                        dark
                        text
                        @click.native="openFileDialog"
                      >
                        Select Image
                      </v-btn>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>

            <v-btn
              color="primary"
              @click="e1 = 2"
            >
              Continue
            </v-btn>

            <v-btn text>Cancel</v-btn>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-card
              class="mb-12"
              color="grey lighten-1"
              height="200px"
            ></v-card>

            <v-btn
              color="primary"
              @click="e1 = 3"
            >
              Continue
            </v-btn>

            <v-btn text>Cancel</v-btn>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-card
              class="mb-12"
              color="grey lighten-1"
              height="200px"
            ></v-card>

            <v-btn
              color="primary"
              @click="e1 = 1"
            >
              Continue
            </v-btn>

            <v-btn text>Cancel</v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'NewEntry',
  computed: {
    ...mapState({
      dialog: state => state.submissionFormOpen,
    }),
  },
  data: () => ({
    formData: new FormData(),
  }),
  methods: {
    ...mapActions({
      toggle: 'toggleForm', // map `this.toggle()` to `this.$store.dispatch('toggleForm')`
    }),
    toggleForm() {
      this.toggle();
    },
    openFileDialog() {
      document.getElementById('file-upload').click();
    },
    onFileChange(e) {
      const self = this;
      const files = e.target.files || e.dataTransfer.files;
      if (files.length > 0) {
        for (let i = 0; i < files.length; i ++){
          self.formData.append('file', files[i], files[i].name);
        }
      }
    },
    uploadFile() {
      const self = this;
      axios.post('URL', self.formData).then(function (response) {
        console.log(response);
      }).catch(function (error) {
        console.log(error);
      });
    },
  },
};
</script>

<style scoped>

</style>
